import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import { FORMATIONS, FORMATION_KEYS, GROUP_LABELS } from '../utils/formations';
import { getSquad, getPlayersForGroup } from '../utils/squadApi';
import LineupPitch from './LineupPitch';
export default class LineupModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.formation = '4-4-2';
    this.selectedPlayers = {};
    this.squad = null;
    this.initSlots();
    getSquad().then(data => {
      this.squad = data;
      m.redraw();
    });
  }
  initSlots() {
    this.selectedPlayers = {};
    const slots = FORMATIONS[this.formation].slots;
    slots.forEach((slot, i) => {
      this.selectedPlayers[i] = '';
    });
  }
  className() {
    return 'LineupModal';
  }
  title() {
    return 'Välj din startelva';
  }
  onsubmit(e) {
    e.preventDefault();
  }
  onready() {
    // Don't auto-focus anything
  }
  content() {
    const self = this;
    const formationDef = FORMATIONS[this.formation];
    const slots = formationDef.slots;

    // Group slot indices by position, keeping slot label
    const groups = {};
    slots.forEach((slot, i) => {
      if (!groups[slot.group]) groups[slot.group] = [];
      groups[slot.group].push({
        index: i,
        label: slot.label
      });
    });
    const groupOrder = ['mv', 'fb', 'mf', 'af'];
    const children = [];

    // Formation selector
    children.push(m('.Form-group', [m('label', 'Formation'), m('select', {
      className: 'FormControl',
      value: this.formation,
      onchange: function () {
        self.formation = this.value;
        self.initSlots();
        m.redraw();
      }
    }, FORMATION_KEYS.map(function (key) {
      return m('option', {
        value: key
      }, FORMATIONS[key].label);
    }))]));

    // Collect all already-selected player names
    var takenNames = {};
    Object.keys(self.selectedPlayers).forEach(function (key) {
      var name = self.selectedPlayers[key];
      if (name) takenNames[name] = true;
    });

    // Player selectors per group
    groupOrder.forEach(function (group) {
      if (!groups[group]) return;
      // Goalkeepers only get MV players; all other positions get all outfield players
      var players;
      if (group === 'mv') {
        players = self.squad ? getPlayersForGroup(self.squad, 'mv') : [];
      } else {
        players = self.squad ? [].concat(getPlayersForGroup(self.squad, 'fb'), getPlayersForGroup(self.squad, 'mf'), getPlayersForGroup(self.squad, 'af')) : [];
      }
      children.push(m('.Form-group', [m('label', GROUP_LABELS[group]), m('.ois-lineup-modal-slots', groups[group].map(function (slot) {
        var currentValue = self.selectedPlayers[slot.index] || '';
        return m('.ois-lineup-modal-slot', [m('span.ois-lineup-modal-slot-label', slot.label), m('select', {
          className: 'FormControl ois-lineup-modal-select',
          value: currentValue,
          onchange: function () {
            self.selectedPlayers[slot.index] = this.value;
            m.redraw();
          }
        }, [m('option', {
          value: ''
        }, 'Välj spelare...')].concat(players.map(function (p) {
          var taken = takenNames[p.name] && p.name !== currentValue;
          return m('option', {
            value: p.name,
            disabled: taken
          }, (p.number ? p.number + '. ' : '') + p.name);
        })))]);
      }))]));
    });

    // Preview
    children.push(m('.ois-lineup-modal-preview', [m(LineupPitch, {
      formation: this.formation,
      players: this.buildPlayersText()
    })]));

    // Insert button
    children.push(m('.Form-group', [m(Button, {
      className: 'Button Button--primary',
      onclick: function (e) {
        e.preventDefault();
        self.insertLineup();
      }
    }, 'Infoga')]));
    return m('.Modal-body', children);
  }
  buildPlayersText() {
    const formationDef = FORMATIONS[this.formation];
    const slots = formationDef.slots;
    const grouped = {};
    slots.forEach((slot, i) => {
      if (!grouped[slot.group]) grouped[slot.group] = [];
      const name = this.selectedPlayers[i];
      if (name) grouped[slot.group].push(name);
    });
    const lines = [];
    ['mv', 'fb', 'mf', 'af'].forEach(function (group) {
      if (grouped[group] && grouped[group].length > 0) {
        lines.push(GROUP_LABELS[group] + ': ' + grouped[group].join(', '));
      }
    });
    return lines.join('\n');
  }
  insertLineup() {
    const text = this.buildPlayersText();
    if (!text) return;
    const bbcode = '[lineup formation="' + this.formation + '"]\n' + text + '\n[/lineup]';
    this.attrs.onsubmit(bbcode);
    this.hide();
  }
}
flarum.reg.add('ois-lineup', 'forum/components/LineupModal', LineupModal);